module.exports = __webpack_public_path__ + "img/logo.02a1b18e.jpg";